import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Directive, Input, Output, HostListener, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { fromEvent } from 'rxjs';
import { convertToRelativeRem } from '@appkit4/angular-components/utils';
import * as i1 from '@appkit4/angular-api';

class TooltipDirective {
    constructor(renderer, element, viewContainer, localizationConfig) {
        this.renderer = renderer;
        this.element = element;
        this.viewContainer = viewContainer;
        this.localizationConfig = localizationConfig;
        this.content = "";
        this.distance = 8;
        this.direction = "right";
        this.dark = false;
        this.tooltipStyle = "";
        this.trigger = "hover";
        this.tooltipDisabled = false;
        this.tooltipStyleClass = "";
        this.tooltipId = new Date().getTime().toString();
        this.duration = 200;
        this.autoLoad = true;
        this.stopPropagation = true;
        this.hideTooltipOnBlur = true;
        this.appendAfterTarget = false;
        this.onMouseEnter = new EventEmitter();
        this.onMouseLeave = new EventEmitter();
        this.offsetLeft = 0;
        this.offsetTop = 0;
        this.listener = [];
        this.destoryTimeout = null;
        this.isStringTooltip = true;
    }
    ngOnInit() {
        if (this.autoLoad)
            this.generateTooltip();
    }
    checkMouseIn() {
        const x = Number(window.event.clientX);
        const y = Number(window.event.clientY);
        const target = this.element.nativeElement.getBoundingClientRect();
        const targetLeft = Number(target.left);
        const targetRight = Number(target.left + target.width);
        const targetTop = Number(target.top);
        const targetBottom = Number(target.top + target.height);
        return (x > targetLeft &&
            x < targetRight &&
            y > targetTop &&
            y < targetBottom);
    }
    ngOnChanges(changes) {
        if (this.tooltip && changes.content && !changes.content.firstChange) {
            // this.tooltip.innerText = this.content;
            this.align();
            if (this.trigger === "hover" && this.checkMouseIn()) {
                this.ngOnDestory();
                setTimeout(() => {
                    this.showTooltip();
                });
            }
            else {
                this.ngOnDestory();
            }
        }
        // Change className of tooltip according to 'styleClass'
        if (this.tooltip &&
            changes.styleClass &&
            !changes.styleClass.firstChange) {
            const defaultClassName = "ap-tooltip ap-tooltip-" + this.direction;
            this.tooltip.className = changes.styleClass.currentValue
                ? defaultClassName + " " + changes.styleClass.currentValue
                : defaultClassName;
        }
        // Remove or display tooltip according to the value of tooltipDisabled dynamically
        if (changes.tooltipDisabled &&
            !changes.tooltipDisabled.firstChange &&
            this.trigger === "hover") {
            if (this.tooltip && changes.tooltipDisabled.currentValue) {
                this.ngOnDestory();
            }
            else if (this.checkMouseIn() &&
                !changes.tooltipDisabled.currentValue) {
                this.ngOnDestory();
                setTimeout(() => {
                    this.showTooltip();
                });
            }
        }
    }
    ngOnDestory() {
        this.destoryTooltip();
    }
    generateTooltip() {
        // clearTimeout(this.destoryTimeout);
        if (this.tooltip) {
            this.renderer.removeChild(this.tooltip.parentNode, this.tooltip);
            this.tooltip = null;
        }
        if (!this.content)
            return;
        this.scrollObservable$ = fromEvent(window, "scroll");
        this.scrollSubscription$ = this.scrollObservable$.subscribe((event) => {
            this.align();
            this.ngOnDestory();
        });
        this.keydownObservable$ = fromEvent(window, "keydown");
        this.keydownSubscription$ = this.keydownObservable$.subscribe((event) => {
            if (event.keyCode === 27) {
                this.hideTooltip();
            }
        });
        this.clickObservable$ = fromEvent(window, "click");
        this.clickSubscription$ = this.clickObservable$.subscribe((event) => {
            if (event.target === this.element.nativeElement) {
                event.stopPropagation();
                return;
            }
            if (this.trigger === "outside") {
                this.hideTooltip();
            }
        });
        if (this.appendAfterTarget) {
            this.element.nativeElement.after((this.tooltip = this.renderer.createElement("div")));
        }
        else {
            this.renderer.appendChild(document.body, (this.tooltip = this.renderer.createElement("div")));
        }
        this.tooltipText = document.createElement("div");
        this.tooltipText.className = "ap-tooltip-text";
        this.tooltipText.style.setProperty("pointer-events", "none");
        this.isStringTooltip = typeof this.content === "string" ? true : false;
        if (this.content && this.isStringTooltip) {
            this.tooltipText.innerHTML = this.content.replace(/[<>&"]/g, function (c) {
                return ({ "<": "&lt", ">": "&gt", "&": "&amp", '"': "&quot" }[c] || "");
            });
        }
        else {
            this.tooltipText = this.content;
        }
        if (this.trigger === "hover") {
            this.tooltip.onmouseover = () => {
                clearTimeout(this.timer);
            };
            this.tooltip.onmouseout = () => {
                this.hideTooltip();
                this.onMouseLeave.emit();
            };
        }
        // let tooltipSpan = document.createElement('span');
        // tooltipSpan.setAttribute('aria-label', 'Tooltip,');
        // this.tooltip.appendChild(tooltipSpan);
        if (this.isStringTooltip) {
            this.tooltip.appendChild(this.tooltipText);
        }
        else {
            const embeddedViewRef = this.viewContainer.createEmbeddedView(this.tooltipText);
            embeddedViewRef.detectChanges();
            embeddedViewRef.rootNodes.forEach((n) => {
                this.renderer.appendChild(this.tooltip, n);
            });
        }
        this.tooltip.classList.add(this.direction);
        this.tooltip.setAttribute("tooltip", "tooltip");
        this.tooltip.style.setProperty("word-break", "break-word");
        this.tooltip.style.setProperty("overflow", "auto");
        this.tooltip.style.setProperty("max-height", "100%");
        this.tooltip.style.setProperty("max-width", "100%");
        this.tooltip.setAttribute("role", "tooltip");
        this.tooltip.setAttribute("id", this.tooltipId);
        this.tooltip.setAttribute("aria-label", this._tooltipLabel);
        let defaultClassName = "ap-tooltip ap-tooltip-" + this.direction;
        this.tooltip.className = this.tooltipStyleClass
            ? defaultClassName + " " + this.tooltipStyleClass
            : defaultClassName;
        const tooltip = this.tooltip.getBoundingClientRect();
        if (tooltip.height > 32) {
            this.tooltip.style.setProperty("padding", "0.5rem 0.625rem");
        }
        // merge the user's style and the default style
        if (this.tooltipStyle) {
            if (typeof this.tooltipStyle === "string") {
                this.tooltip.style.cssText += this.tooltipStyle;
            }
            else {
                Object.assign(this.tooltip.style, this.tooltipStyle);
            }
        }
        this.align();
        var node = this.element?.nativeElement;
        while (node?.parentNode) {
            this.listener.push(this.renderer.listen(node, "scroll", () => {
                this.align();
            }));
            node = node.parentNode;
        }
    }
    destoryTooltip() {
        while (this.listener.length) {
            this.listener.pop()();
        }
        clearTimeout(this.destoryTimeout);
        this.destoryTimeout = setTimeout(() => {
            if (this.tooltip && this.tooltip.parentNode)
                this.renderer.removeChild(this.tooltip.parentNode, this.tooltip);
            this.tooltip = null;
        }, 0);
        this.scrollSubscription$?.unsubscribe();
        this.keydownSubscription$?.unsubscribe();
        this.clickSubscription$?.unsubscribe();
    }
    showTooltip() {
        if (Array.from(this.element.nativeElement.classList).indexOf("hide-tooltip") !== -1 ||
            !this.content)
            return;
        this.generateTooltip();
        setTimeout(() => {
            this.align();
            this.tooltip?.classList.add("show");
        }, 0);
    }
    hideTooltip() {
        if (!this.tooltip) {
            return;
        }
        this.tooltip?.classList.remove("show");
        if (!this.autoLoad)
            this.destoryTooltip();
        this.onMouseLeave.emit();
        this.scrollSubscription$?.unsubscribe();
        this.keydownSubscription$?.unsubscribe();
        this.clickSubscription$?.unsubscribe();
    }
    align() {
        if (!this.tooltip) {
            return;
        }
        switch (this.direction) {
            case "top-left":
            case "top-right":
            case "top":
                this.alignTop();
                if (this.isOutOfBounds()) {
                    this.alignBottom();
                    if (this.isOutOfBounds()) {
                        this.alignRight();
                        if (this.isOutOfBounds()) {
                            this.alignLeft();
                        }
                    }
                }
                break;
            case "bottom-left":
            case "bottom-right":
            case "bottom":
                this.alignBottom();
                if (this.isOutOfBounds()) {
                    this.alignTop();
                    if (this.isOutOfBounds()) {
                        this.alignRight();
                        if (this.isOutOfBounds()) {
                            this.alignLeft();
                        }
                    }
                }
                break;
            case "left-top":
            case "left-bottom":
            case "left":
                this.alignLeft();
                if (this.isOutOfBounds()) {
                    this.alignRight();
                    if (this.isOutOfBounds()) {
                        this.alignTop();
                        if (this.isOutOfBounds()) {
                            this.alignBottom();
                        }
                    }
                }
                break;
            case "right-top":
            case "right-bottom":
            case "right":
                this.alignRight();
                if (this.isOutOfBounds()) {
                    this.alignLeft();
                    if (this.isOutOfBounds()) {
                        this.alignTop();
                        if (this.isOutOfBounds()) {
                            this.alignBottom();
                        }
                    }
                }
                break;
        }
        if (this.dark) {
            this.tooltip.classList.add("dark");
        }
        else {
            this.tooltip.classList.remove("dark");
        }
    }
    alignTop() {
        let defaultClassName = "ap-tooltip ap-tooltip-" + this.direction;
        this.tooltip.className = this.tooltipStyleClass
            ? defaultClassName + " " + this.tooltipStyleClass
            : defaultClassName;
        const host = this.element.nativeElement.getBoundingClientRect();
        const tooltip = this.tooltip.getBoundingClientRect();
        let left = host.left + (host.width - tooltip.width) / 2;
        switch (this.direction) {
            case "top-left":
                left = host.left;
                break;
            case "top-right":
                left = host.right - tooltip.width;
                break;
        }
        let top = host.top - tooltip.height - parseInt(this.distance);
        this.tooltip.style.left = convertToRelativeRem(left);
        this.tooltip.style.top = convertToRelativeRem(top);
        if (this.isOutOfBounds()) {
            left = host.left;
            this.tooltip.style.left = convertToRelativeRem(left);
            if (this.isOutOfBounds()) {
                left = host.right - tooltip.width;
                if (left < 0)
                    left = 0;
                this.tooltip.style.left = convertToRelativeRem(left);
            }
        }
    }
    alignBottom() {
        let defaultClassName = "ap-tooltip ap-tooltip-" + this.direction;
        this.tooltip.className = this.tooltipStyleClass
            ? defaultClassName + " " + this.tooltipStyleClass
            : defaultClassName;
        const host = this.element.nativeElement.getBoundingClientRect();
        const tooltip = this.tooltip.getBoundingClientRect();
        let left = host.left + (host.width - tooltip.width) / 2;
        switch (this.direction) {
            case "bottom-left":
                left = host.left;
                break;
            case "bottom-right":
                left = host.right - tooltip.width;
                break;
        }
        let top = host.bottom + parseInt(this.distance);
        this.tooltip.style.left = convertToRelativeRem(left);
        this.tooltip.style.top = convertToRelativeRem(top);
        if (this.isOutOfBounds()) {
            left = host.left;
            this.tooltip.style.left = convertToRelativeRem(left);
            if (this.isOutOfBounds()) {
                left = host.right - tooltip.width;
                if (left < 0)
                    left = 0;
                this.tooltip.style.left = convertToRelativeRem(left);
            }
        }
    }
    alignRight() {
        let defaultClassName = "ap-tooltip ap-tooltip-" + this.direction;
        this.tooltip.className = this.tooltipStyleClass
            ? defaultClassName + " " + this.tooltipStyleClass
            : defaultClassName;
        const host = this.element.nativeElement.getBoundingClientRect();
        const tooltip = this.tooltip.getBoundingClientRect();
        let left = host.left + host.width + parseInt(this.distance);
        let top = host.top + (host.height - tooltip.height) / 2;
        switch (this.direction) {
            case "right-top":
                top = host.top;
                break;
            case "right-bottom":
                top = host.bottom - tooltip.height;
                break;
        }
        this.tooltip.style.left = convertToRelativeRem(left);
        this.tooltip.style.top = convertToRelativeRem(top);
        if (this.isOutOfBounds()) {
            top = host.top;
            this.tooltip.style.top = convertToRelativeRem(top);
            if (this.isOutOfBounds()) {
                top = host.bottom - tooltip.height;
                if (top < 0)
                    top = 0;
                this.tooltip.style.top = convertToRelativeRem(top);
            }
        }
    }
    alignLeft() {
        let defaultClassName = "ap-tooltip ap-tooltip-" + this.direction;
        this.tooltip.className = this.tooltipStyleClass
            ? defaultClassName + " " + this.tooltipStyleClass
            : defaultClassName;
        const host = this.element.nativeElement.getBoundingClientRect();
        const tooltip = this.tooltip.getBoundingClientRect();
        let left = host.left - tooltip.width - parseInt(this.distance);
        let top = host.top + (host.height - tooltip.height) / 2;
        switch (this.direction) {
            case "left-top":
                top = host.top;
                break;
            case "left-bottom":
                top = host.bottom - tooltip.height;
                break;
        }
        this.tooltip.style.left = convertToRelativeRem(left);
        this.tooltip.style.top = convertToRelativeRem(top);
        if (this.isOutOfBounds()) {
            top = host.top;
            this.tooltip.style.top = convertToRelativeRem(top);
            if (this.isOutOfBounds()) {
                top = host.bottom - tooltip.height;
                if (top < 0)
                    top = 0;
                this.tooltip.style.top = convertToRelativeRem(top);
            }
        }
    }
    isOutOfBounds() {
        let { top, left, width, height } = this.tooltip.getBoundingClientRect();
        let viewport = this.getViewport();
        return (left + width > viewport.width ||
            left < 0 ||
            top < 0 ||
            top + height > viewport.height);
    }
    getViewport() {
        let win = window, d = document, e = d.documentElement, g = d.getElementsByTagName("body")[0], w = win.innerWidth || e.clientWidth || g.clientWidth, h = win.innerHeight || e.clientHeight || g.clientHeight;
        return { width: w, height: h };
    }
    mouseEnter(event) {
        if (this.timer)
            clearTimeout(this.timer);
        if (this.trigger === "hover" &&
            !this.tooltipDisabled &&
            (!this.tooltip ||
                (this.tooltip &&
                    Array.from(this.tooltip.classList).indexOf("show") === -1))) {
            this.showTooltip();
        }
        this.onMouseEnter.emit();
    }
    mouseLeave(event) {
        this.timer = setTimeout(() => {
            if (this.trigger === "hover") {
                this.hideTooltip();
            }
            this.onMouseLeave.emit();
        }, this.duration);
    }
    handleFocus(event) {
        if (this.trigger === "hover") {
            if (event) {
                let ev = event.event
                    ? event.event
                    : event.originEvent
                        ? event.originEvent
                        : event;
                ev.preventDefault();
                if (this.stopPropagation) {
                    ev.stopPropagation();
                }
            }
            if (this.tooltipDisabled)
                return; // Set no response if 'tooltipDisabled' is true
            if (!this.tooltip ||
                (this.tooltip &&
                    Array.from(this.tooltip.classList).indexOf("show") === -1))
                this.showTooltip();
        }
    }
    handleBlur(event) {
        if (this.hideTooltipOnBlur &&
            this.tooltip &&
            Array.from(this.tooltip.classList).indexOf("show") !== -1)
            this.hideTooltip();
    }
    click(event) {
        event.preventDefault();
        if (this.tooltipDisabled)
            return;
        if (this.trigger === "outside" || this.stopPropagation)
            event.stopPropagation();
        if ((this.trigger === "click" || this.trigger === "outside") &&
            (!this.tooltip ||
                (this.tooltip &&
                    Array.from(this.tooltip.classList).indexOf("show") === -1))) {
            this.showTooltip();
        }
        else if (this.trigger === "click" &&
            this.tooltip &&
            Array.from(this.tooltip.classList).indexOf("show") !== -1) {
            this.hideTooltip();
        }
    }
    handleKeyDown(event) {
        if (this.trigger === "click" &&
            (event.keyCode === 13 || event.keyCode === 32)) {
            event.preventDefault();
            if (this.stopPropagation)
                event.stopPropagation();
            if (!this.tooltip ||
                (this.tooltip &&
                    Array.from(this.tooltip.classList).indexOf("show") === -1))
                this.showTooltip();
            else if (Array.from(this.tooltip.classList).indexOf("show") !== -1)
                this.hideTooltip();
        }
        // else if (event.keyCode === 9) { // when leave the host element, tooltip info will disappear
        //   if (this.tooltip && Array.from(this.tooltip.classList).indexOf('show') !== -1) this.hideTooltip();
        // }
    }
    // when tab to the host element, tooltip info will display
    // @HostListener('keyup', ['$event']) handleKeyup(event: any) {
    //   if (event.keyCode === 9 && !this.tooltipDisabled && (!this.tooltip || (this.tooltip && Array.from(this.tooltip.classList).indexOf('show') === -1))) {
    //     this.showTooltip();
    //   }
    // }
    // @HostListener('window:click', ['$event']) windowClick(event: any) {
    //   if (event.target === this.element.nativeElement) {
    //     event.stopPropagation();
    //     return;
    //   }
    //   if (this.trigger === 'outside') {
    //     this.hideTooltip();
    //   }
    // }
    // @HostListener('window:scroll') windowScroll() {
    //   // If want the tooltip disappear when scroll, need to uncomment the below code
    //   // if (Array.from(this.tooltip.classList).indexOf('show') > -1) {
    //   //   this.align();
    //   //   this.tooltip.classList.add('show');
    //   // } else {
    //   //   this.align();
    //   // }
    //   // If want the tooltip disappear when scroll, need to comment the below one line code
    //   this.align();
    //   this.ngOnDestory();
    // }
    // @HostListener('window:keydown', ['$event']) windowKeydown(event: any) {
    //   if (event.keyCode === 27 && this.tooltip) {
    //     this.hideTooltip();
    //   }
    // }
    windowResize() {
        this.align();
    }
    ngOnDestroy() {
        this.hideTooltip();
        this.destoryTooltip();
    }
    get _tooltipLabel() {
        let tooltipLabel = this.localizationConfig.translation.aria ? this.localizationConfig.translation.aria['tooltipLabel'] : null;
        return tooltipLabel.replaceAll('{content}', this.content);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: TooltipDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i0.ViewContainerRef }, { token: i1.LocalizationConfig }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.11", type: TooltipDirective, selector: "[ap-tooltip]", inputs: { content: ["tooltipContent", "content"], distance: "distance", direction: "direction", dark: "dark", tooltipStyle: "tooltipStyle", trigger: "trigger", tooltipDisabled: "tooltipDisabled", tooltipStyleClass: "tooltipStyleClass", tooltipId: "tooltipId", duration: "duration", autoLoad: "autoLoad", stopPropagation: "stopPropagation", hideTooltipOnBlur: "hideTooltipOnBlur", appendAfterTarget: "appendAfterTarget" }, outputs: { onMouseEnter: "onMouseEnter", onMouseLeave: "onMouseLeave" }, host: { listeners: { "mouseenter": "mouseEnter($event)", "mouseleave": "mouseLeave($event)", "focus": "handleFocus($event)", "onFocus": "handleFocus($event)", "blur": "handleBlur($event)", "onBlur": "handleBlur($event)", "click": "click($event)", "keydown": "handleKeyDown($event)", "window:resize": "windowResize()" } }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: TooltipDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: "[ap-tooltip]",
                }]
        }], ctorParameters: () => [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i0.ViewContainerRef }, { type: i1.LocalizationConfig }], propDecorators: { content: [{
                type: Input,
                args: ["tooltipContent"]
            }], distance: [{
                type: Input
            }], direction: [{
                type: Input
            }], dark: [{
                type: Input
            }], tooltipStyle: [{
                type: Input
            }], trigger: [{
                type: Input
            }], tooltipDisabled: [{
                type: Input
            }], tooltipStyleClass: [{
                type: Input
            }], tooltipId: [{
                type: Input
            }], duration: [{
                type: Input
            }], autoLoad: [{
                type: Input
            }], stopPropagation: [{
                type: Input
            }], hideTooltipOnBlur: [{
                type: Input
            }], appendAfterTarget: [{
                type: Input
            }], onMouseEnter: [{
                type: Output
            }], onMouseLeave: [{
                type: Output
            }], mouseEnter: [{
                type: HostListener,
                args: ["mouseenter", ["$event"]]
            }], mouseLeave: [{
                type: HostListener,
                args: ["mouseleave", ["$event"]]
            }], handleFocus: [{
                type: HostListener,
                args: ["focus", ["$event"]]
            }, {
                type: HostListener,
                args: ["onFocus", ["$event"]]
            }], handleBlur: [{
                type: HostListener,
                args: ["blur", ["$event"]]
            }, {
                type: HostListener,
                args: ["onBlur", ["$event"]]
            }], click: [{
                type: HostListener,
                args: ["click", ["$event"]]
            }], handleKeyDown: [{
                type: HostListener,
                args: ["keydown", ["$event"]]
            }], windowResize: [{
                type: HostListener,
                args: ["window:resize"]
            }] } });
class TooltipModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: TooltipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.11", ngImport: i0, type: TooltipModule, declarations: [TooltipDirective], imports: [CommonModule, FormsModule], exports: [TooltipDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: TooltipModule, imports: [CommonModule, FormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: TooltipModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule],
                    declarations: [TooltipDirective],
                    exports: [TooltipDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TooltipDirective, TooltipModule };
